import { render } from "./ListeTaillePage.vue?vue&type=template&id=156cc8e1&ts=true"
import script from "./ListeTaillePage.vue?vue&type=script&lang=ts"
export * from "./ListeTaillePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__